module.exports = __webpack_public_path__ + "static/media/sketch.94ed2aab.png";